/** Notificări (spec §3) — listă + marcare citit; badge + push live pe WS. */
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNotifications, useMutation, useInvalidate, qk } from '../api/hooks';
import { markAllNotificationsRead, markNotificationRead } from '../api/endpoints';
import { EmptyState, PageHeader, SkeletonCard } from '../components/ui';
import { timeAgo } from '../lib/format';

export function NotificariPage() {
  const notifs = useNotifications();
  const invalidate = useInvalidate();

  useEffect(() => {
    document.title = 'Notificări — Reclame Video';
  }, []);

  const markRead = useMutation({
    mutationFn: (id: string) => markNotificationRead(id),
    onSuccess: () => invalidate([qk.notifications]),
  });
  const markAll = useMutation({
    mutationFn: () => markAllNotificationsRead(),
    onSuccess: () => invalidate([qk.notifications]),
  });

  const items = notifs.data?.items ?? [];

  return (
    <div>
      <PageHeader
        title="Notificări"
        subtitle="Primești o notificare la fiecare tranziție importantă — gata de aprobare, livrat, revizie gata, mesaj."
        actions={items.length > 0 && (notifs.data?.unread ?? 0) > 0 ? <button className="btn btn-ghost btn-sm" onClick={() => markAll.mutate()}>Marchează tot citit</button> : undefined}
      />

      {notifs.isLoading ? (
        <SkeletonCard />
      ) : items.length === 0 ? (
        <EmptyState illustration="🔔" title="Nicio notificare" body="Aici apar anunțurile despre clipuri, comenzi și mesaje." />
      ) : (
        <div className="card" style={{ padding: 4 }} data-testid="notifications-list">
          {items.map((n) => (
            <button
              key={n.id}
              onClick={() => !n.read && markRead.mutate(n.id)}
              style={{ width: '100%', textAlign: 'left', display: 'flex', gap: 12, padding: '14px 12px', borderBottom: '1px solid var(--line)' }}
            >
              <span aria-hidden="true" style={{ flex: 'none', marginTop: 5, width: 8, height: 8, borderRadius: '50%', background: n.read ? 'var(--line)' : 'var(--accent)' }} />
              <div style={{ flex: 1 }}>
                <p style={{ margin: 0, fontSize: 14, fontWeight: n.read ? 600 : 800 }}>{n.title}</p>
                {n.body && <p style={{ margin: '3px 0 0', fontSize: 13, color: 'var(--muted)' }}>{n.body}</p>}
                <span style={{ fontSize: 11.5, color: 'var(--muted)' }}>{timeAgo(n.createdAt)}</span>
              </div>
              {n.link && (
                <Link to={n.link} style={{ alignSelf: 'center', fontSize: 12, fontWeight: 800 }} onClick={(e) => e.stopPropagation()}>
                  Deschide →
                </Link>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
